import React from 'react';

const BajaModal = ({
    show,
    colaborador,
    bajaForm,
    handleFormChange,
    handleConfirmarBaja,
    setShowBajaModal,
    error,
    success,
}) => {
    if (!show || !colaborador) return null;

    return (
        <div className="sub-card-overlay">
            <div className="sub-card">
                <div className="sub-card-header">
                    <h3>Solicitud de Baja de Usuario</h3>
                    <button className="sub-card-close" onClick={() => setShowBajaModal(false)}>
                        ×
                    </button>
                </div>

                <div className="sub-card-content">
                    <div className="colaborador-info">
                        <div className="info-row">
                            <span>{colaborador.nombres} {colaborador.apellidos}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">{colaborador.tipo_documento} :</span>
                            <span className="info-value">{colaborador.numero_documento}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">Motivo:</span>
                            <span className="info-value">{colaborador.descripcion_motivo_baja || '-'}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">Comentario:</span>
                            <span className="info-value">{colaborador.comentario || '-'}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">Fecha de Solicitud:</span>
                            <span className="info-value">{new Date(colaborador.fecha_solicitud_baja).toLocaleString('es-PE', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: true // 👈 esto activa el formato AM/PM
                            })}</span>
                        </div>
                    </div>

                    {error && <div className="sub-card-error">{error}</div>}
                    {success && <div className="sub-card-success">{success}</div>}
                </div>

                <div className="sub-card-actions">
                    <button className="sub-card-btn sub-card-btn-secondary" onClick={() => setShowBajaModal(false)}>
                        Cancelar
                    </button>
                    <button className="sub-card-btn sub-card-btn-danger" onClick={handleConfirmarBaja}>
                        Confirmar Baja
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BajaModal;
